import type { RequestContext } from '../requestContext';

function getPassportAuthUrl(env: RequestContext['yandexPassportEnv'], retpath: string = window.location.href) {
    if (env === 'prod') {
        return `https://passport.yandex.ru/auth?retpath=${encodeURIComponent(retpath)}`;
    }

    return `https://passport-test.yandex.ru/auth?retpath=${encodeURIComponent(retpath)}`;
}

export function passportAuthenticate(env: RequestContext['yandexPassportEnv']) {
    window.location.href = getPassportAuthUrl(env);
}
